var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ib-toggle-button", {
    attrs: {
      icon: "ib-icon ib-icon-circled-play",
      title: _vm.$t("quickTour"),
      active: _vm.active,
      "icon-size": "30px",
    },
    on: {
      click: function ($event) {
        return _vm.$emit("click")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }